module.exports = __webpack_public_path__ + "static/media/element2.b33fe941.svg";